import { orderAndFilterFormList } from '@aims/shared/shared/utils';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import React, { useCallback, useEffect } from 'react';
import SelectContact from '../../contacts/SelectContact';
import TaskSomethingForm from '../../tasks/ViewTaskModal/TaskSomethingForm';

function HProjectChangeSupportedFWsInner({
  holisticProject,
  saving,
  handleFinish,
  onCancel,
  title = 'Edit Supported Field Workers',
}) {
  const [form] = Form.useForm();
  useEffect(() => {
    if (holisticProject) {
      form.setFieldsValue({
        regionalCoordId: holisticProject.regionalCoordId,
        supportedFieldWorkers: holisticProject.supportedFieldWorkers,
      });
    }
  }, [holisticProject, form]);
  const _handleFinish = useCallback(
    (_values) => {
      const { supportedFieldWorkers, ...values } = _values;
      const _supportedFieldWorkers = orderAndFilterFormList(
        supportedFieldWorkers,
        (a, b) => {
          return a.contactId.localeCompare(b.contactId);
        },
        'contactId',
        ['contactId', 'totalReceived'],
      );
      handleFinish({
        supportedFieldWorkers: _supportedFieldWorkers,
        ...values,
      });
    },
    [handleFinish],
  );
  return (
    <TaskSomethingForm
      title={title}
      form={form}
      onFinish={_handleFinish}
      onCancel={onCancel}
      saving={saving}
    >
      <Form.Item label="Please list the field workers that will be financially supported by this project">
        <Form.List name="supportedFieldWorkers">
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => (
                <Form.Item
                  key={field.key}
                  style={{ marginBottom: 0 }}
                  shouldUpdate={(prev, curr) =>
                    prev.regionalCoordId !== curr.regionalCoordId
                  }
                >
                  {({ getFieldValue }) => (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <Form.Item
                        label={`Field Worker ${index + 1}`}
                        name={[field.name, 'contactId']}
                        style={{ width: '100%' }}
                        rules={[
                          { required: true, message: 'This field is required' },
                        ]}
                      >
                        <SelectContact
                          disabled={saving}
                          filters={{
                            isFieldWorker: true,
                            regionalCoordId: getFieldValue('regionalCoordId'),
                          }}
                        />
                      </Form.Item>
                      <MinusCircleOutlined
                        className="dynamic-delete-button"
                        onClick={() => {
                          remove(field.name);
                        }}
                        style={{ marginLeft: 8 }}
                      />
                    </div>
                  )}
                </Form.Item>
              ))}
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  icon={<PlusOutlined />}
                >
                  Add field worker
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form.Item>
    </TaskSomethingForm>
  );
}

export default HProjectChangeSupportedFWsInner;
